import { makeStyles } from 'tss-react/mui';

const useStylesTableCellExtended: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  tableCellExtended: {
    minWidth: '200px !important',
    width: '200px !important',
  },
  tableCellExtendedEdit: {
    minWidth: '450px !important',
    width: '450px !important',
  },
  tableCellExtendedLarge: {
    minWidth: '1000px !important',
    width: '1000px !important',
  },
}));

export default useStylesTableCellExtended;
